import { axiosInstance } from './axios-instance';
import { API_DOMAIN } from '../magic-values';
import type { CurrentUser, CurrentUserResponse } from '../types/auth';

// `/auth` exists only at the unversioned API root, and `VITE_API_DOMAIN`
// sometimes carries `/api/v1`, so this one call overrides the axios baseURL.
const API_ROOT = API_DOMAIN.replace(/\/api\/v\d+\/?$/, '');

/** Unlike every other service here, these paths carry no `/admin` prefix. */
export class AuthService {
  static async getCurrentUser(): Promise<CurrentUser> {
    const res = await axiosInstance.get<CurrentUserResponse>('/auth/me', { baseURL: API_ROOT });
    return res.data.user;
  }
}
